import { motion } from "framer-motion";

// Selbst gezeichnete, dezente Architektur-Linienskizzen (keine Fremdfotos).
// Zeichnen sich beim Scrollen sanft selbst (pathLength) und leuchten bei Hover
// im Akzentton auf. currentColor wird vom Wrapper gesteuert.

const draw = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: {
    pathLength: 1,
    opacity: 1,
    transition: {
      pathLength: { duration: 1.15, ease: [0.22, 1, 0.36, 1] },
      opacity: { duration: 0.25 },
    },
  },
};

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.09 } },
};

// Haus T: Bestand-Erdgeschoss + Aufstockung (gestrichelt = neue Etage oben)
const HAUS_SOLID = [
  "M12 120 H208", // Bodenlinie
  "M60 120 V84 H160 V120", // Bestand Erdgeschoss
  "M76 98 H94 V114 H76 Z", // EG-Fenster
  "M126 120 V96 H144 V120", // EG-Eingang
];
const HAUS_DASHED = [
  "M60 84 V54 H160 V84", // Aufstockung (neues Obergeschoss)
  "M52 54 L110 26 L168 54", // neues Satteldach
  "M128 40 V28 H138 V47", // Kamin
  "M78 62 H96 V76 H78 Z", // OG-Fenster links
  "M124 62 H142 V76 H124 Z", // OG-Fenster rechts
];

// Energy On Site: Bürogebäude Flachdach + angebaute Werkhalle (+ Solar = Energie)
const HQ_SOLID = [
  "M12 120 H208", // Bodenlinie
  "M28 120 V50 H108 V120", // Bürogebäude (Flachdach)
  "M24 50 H112", // Attika / Parapet
  "M28 72 H108 M28 94 H108", // Geschossbänder
  "M50 50 V120 M72 50 V120 M90 50 V120", // Mullions
  "M108 120 V66 H192 V120", // Werkhalle Körper
  "M104 66 H196", // Werkhalle Flachdach (Attika)
  "M150 120 V86 H184 V120", // Hallentor
  "M114 100 H144", // Fassadenband Halle
];
const HQ_ACCENT = [
  "M128 60 L170 60 L165 55 L123 55 Z", // Solar-Panel (leicht geneigt) auf Werkhallendach
  "M132 59 L130 66 M146 57 L144 66 M160 55 L158 66", // Panel-Aufständerung
];

const Path = ({ d, dashed, accent }) => (
  <motion.path
    d={d}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.25}
    strokeLinecap="round"
    strokeLinejoin="round"
    vectorEffect="non-scaling-stroke"
    variants={draw}
    style={dashed ? { strokeDasharray: "4 4", opacity: 0.75 } : accent ? { opacity: 0.9 } : undefined}
  />
);

export const ProjectSketch = ({ variant = "haus", hover = false, className = "" }) => {
  const isHaus = variant !== "firmensitz";
  return (
    <motion.svg
      viewBox="0 0 220 130"
      className={`w-full h-auto transition-colors duration-500 ${className}`}
      style={{ color: hover ? "#d9cfb8" : "#5f5a51" }}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.6 }}
      aria-hidden="true"
    >
      {isHaus ? (
        <>
          {HAUS_SOLID.map((d, i) => (
            <Path key={`s${i}`} d={d} />
          ))}
          {HAUS_DASHED.map((d, i) => (
            <Path key={`d${i}`} d={d} dashed />
          ))}
        </>
      ) : (
        <>
          {HQ_SOLID.map((d, i) => (
            <Path key={`s${i}`} d={d} />
          ))}
          {HQ_ACCENT.map((d, i) => (
            <Path key={`a${i}`} d={d} accent />
          ))}
        </>
      )}
    </motion.svg>
  );
};
